import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { CoreModule } from './core/core.module';
//import { LoginPageModule } from '../pages/login/login.module';
import { RegistrationPageModule } from '../pages/registration/registration.module';
import { createTranslateLoader } from './utils/translate-module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NavigationService } from './services/navigation/navigation.service';

import { LoaderService } from './services/loader/loader.service';
import { File } from '@ionic-native/file';
import { UserModule } from './user/user.module';
import { FileTransfer } from '@ionic-native/file-transfer';

import { ChangePasswordPageModule } from '../pages/change-password/change-password.module';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp, {
      monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre' ],
      backButtonIcon: '',
      iconMode: 'ios'
    }),
    CoreModule,
    UserModule.forRoot(),
    
    //pages

    //LoginPageModule,
    RegistrationPageModule,
    ChangePasswordPageModule
    //LoginPageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: LOCALE_ID, useValue: "it"},
    HttpClient,
    NavigationService,
    
    LoaderService,
    FileTransfer,
    File
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts